/**
 * Formatea valores monetarios para Honduras (Lempira o USD)
 */
export const formatCurrency = (value, currency = 'HNL') => {
  if (!value && value !== 0) return '';
  
  if (currency === 'HNL') {
    return 'L. ' + new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};